<template>
  <v-container fluid>
    <v-row>
      <v-col class="tw-px-0">
        <Top :info="info" />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="isAdd ? 8: 12" class="tw-px-0">
        <McTable
          :isHideMenu="false"
          :isHideAdd="false"
          :isHideSettings="false"
          :isLoading="isFetching"
          :search="search"
          :tabs="false"
          :headers="headers"
          :items="newItems"
          :footerProps="{}"
          :paging="paging"
          :pagingOptions="pagingOptions"
          :showExpand="false"
          :isTuneIcon="true"
          :itemsAction="true"
          :onAdd="doToggleAdd"
        >
        </McTable>
      </v-col>
      <v-col v-if="isAdd">
        <v-card
          elevation="2"
          rounded="xl"
        >
          <SearchUser
            :userSearch="userSearch"
            :items="customers"
            :doSearchUser="doSearchUser"
            :doUpdateData="doUpdateData"  
            :isLoading="isCustomerSearch || isProcessing"
            :doAddToQueue="doAddToQueue"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

// Utilities
import {
  cloneDeep,
  // get
} from 'lodash'

import {
  mapState,
  // mapActions,
  // mapMutations
} from 'vuex'
import {
  UPDATE_BYO_STORE_STATE,
  REQUEST_BYO_STORE_LIST,
  REQUEST_BYO_CUSTOMER_LIST,
  REQUEST_BYO_ADD_USER_QUEUE,
  REQUEST_BYO_UPDATE_USER_STATUS,
// RESET_PRODUCT_STATE,
} from '@/store/modules/buildYourOwn'
import { initComponent } from '@/lib'


export default initComponent ('BuildYourOwn', {
  isPage: true,
  components : {
    // Chart1: () => import('./components/widgets/ChartOne'),
    McTable: () => import('@/components/base//Table'),
    Top: () => import('../techBar/components/Top.vue'),
    SearchUser: () => import('../techBar/components/SearchUser.vue'),

  },
  data () {
    return {
      headers: [
        {
          text: 'Customer Name',
          align: 'start',
          class: '',
          sortable: true,
          width: '20%',
          value: 'customer_name',
        },
        { text: 'Status', value: 'status', align: 'center'},
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'actions',
          width: '30%',
        },
      ],
      recent: [
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          name: 'Jason Oner',
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          name: 'Mike Carlson',
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
          name: 'Cindy Baker',
        },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
          name: 'Ali Connors',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      isCustomerSearch: (state) => state.buildYourOwn.isCustomerSearch,
      isFetching: (state) => state.buildYourOwn.isFetching,
      isProcessing: (state) => state.buildYourOwn.isProcessing,
      items: (state) => state.buildYourOwn.items,
      paging: (state) => state.buildYourOwn.paging,
      item: (state) => state.buildYourOwn.item,
      search: (state) => state.buildYourOwn.search,
      userSearch: (state) => state.buildYourOwn.userSearch,
      isAdd: (state) => state.buildYourOwn.isAdd,
      customers: (state) => state.buildYourOwn.customers,
      customer: (state) => state.buildYourOwn.customer,
      customerPaaging: (state) => state.buildYourOwn.customerPaaging,
      info: (state) => state.buildYourOwn.info,
    }),
    newItems: function () { //add call to actioon array for assist and remove
      let newItems = [];
      this.items.map(item => {
        if (item.status === 'requested') {
          newItems.push({
            ...item,
            actions: [
              {
                label: 'Assist',
                action: this.doAssist,
                class: 'tw-text-success'
              },
              {
                label: 'Remove',
                action: this.doRemove,
                class: 'tw-text-error'
              }
            ],
          });
          return;
        }
        newItems.push({
          ...item,
          actions: [
            {
              label: 'Remove',
              action: this.doRemove,
              class: 'tw-text-error'
            }
          ],
        });
      });

      return newItems;
    },
    pagingOptions() { // need to add this if to table props for paginations to work
      let option = {
        state: 'buildYourOwn',
        commit: UPDATE_BYO_STORE_STATE,
        dispatch: REQUEST_BYO_STORE_LIST,
      }
      return option;
    }
  },
  methods: {
    async onReady () {
      // return this.$store.commit(UPDATE_STORE_STATE)
      const { dispatch } = this.$store
      dispatch(REQUEST_BYO_STORE_LIST);

      window.setInterval(() => {
        dispatch(REQUEST_BYO_STORE_LIST);
      }, 60000);
    },
    doUpdateData (value, key) {
      const { commit, state } = this.$store
      let userSearch = cloneDeep(state.buildYourOwn.userSearch)
      userSearch = value
      return commit(UPDATE_BYO_STORE_STATE, { [`${key}`] : userSearch })
    },
    doToggleAdd () {
      const { commit } = this.$store;
      commit(UPDATE_BYO_STORE_STATE, { isAdd : !this.isAdd} );
    },
    doSearchUser () {
      const { dispatch, commit } = this.$store;
      commit(UPDATE_BYO_STORE_STATE, { customer : {} });
      dispatch(REQUEST_BYO_CUSTOMER_LIST);
    },
    async doAddToQueue ( item ) {
      const { commit, dispatch} = this.$store;
      await commit(UPDATE_BYO_STORE_STATE, { customer : item });
      await dispatch(REQUEST_BYO_ADD_USER_QUEUE);
    },
    async doAssist ( item ) {
      let status = 'response'
      const { commit, dispatch, state } = this.$store;
      const { app } = state;
      await commit(UPDATE_BYO_STORE_STATE, { item : {...item, status : status, admin: {...app.admin}} });
      await dispatch(REQUEST_BYO_UPDATE_USER_STATUS);
    },
    async doRemove ( item ) {
      let status = 'complete'
      const { commit, dispatch, state } = this.$store;
      const { app } = state;
      await commit(UPDATE_BYO_STORE_STATE, { item : {...item, status : status, admin: {...app.admin}} });
      await dispatch(REQUEST_BYO_UPDATE_USER_STATUS);
    },
    
  }
})
</script>

<style lang="sass" scoped>

</style>